import { createSelector } from '@reduxjs/toolkit';
import { selectActivityItinerary, selectExpandedAccordionFromDetailState } from 'component/page/detail/store/detail.selectors';
import { ItineraryReference } from 'gql/autogen/ItineraryReference';
import { DetailContentOnToggleProps } from 'component/page/detail/DetailPageContent/DetailPageContent.selectors';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { ExpandedAccordionDict } from 'core/type/Details.types';

interface StateProps {
    cms: CmsValue;
    itinerary?: ItineraryReference;
    expandedAccordion: ExpandedAccordionDict;
}

export type WhatToExpectProps = StateProps & DetailContentOnToggleProps;

export type WhatToExpectModularProps = StateProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectActivityItinerary,
    selectExpandedAccordionFromDetailState,
    (cms, itinerary, expandedAccordion): StateProps => {
        return { cms, itinerary, expandedAccordion };
    },
);
